import React from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AuthContext } from '../../Context/UserContext';

const Signin = () => {

    const { user, setLoading, signIn, singInWithGoogle, signInWithGithub, signInWithFacebook, userPasswordCorrection } = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();
    const [error, setError] = useState('');
    const [email, setEmail] = useState();

    const from = location.state?.from?.pathname || "/";

    // Sign in with Google
    const handleGoogleSignIn = () => {
        singInWithGoogle()
            .then(result => {
                const user = result.user;
                toast.success('Sign-In with Google');
                setError('');
                navigate('/');
            })
            .catch(error => {
                setError(error.message);
                setError(error.message);
            })
            .finally(() => {
                setLoading(false);
            })
    }

    // Sign in With Facebook
    const handleFacebookSignIn = () => {
        signInWithFacebook()
            .then(result => {
                toast.success('Sign-In With Facebook');
                setError('');
                navigate('/');
            })
            .catch(error => {
                toast.error(error.message)
                setError(error.message);
            })
    }

    // Sign in with Github
    const handleGithubSignIn = () => {
        signInWithGithub()
            .then(result => {
                const user = result.user;
                toast.success('Sign-In with Github');
                setError('');
                navigate('/');
            })
            .catch(error => {
                setError(error.message);
                toast.error(error.message);
            })
    }



    const handleOnSubmit = (event) => {
        event.preventDefault()
        const form = event.target;
        const email = form.email.value;
        const password = form.password.value;
        console.log(email, password);


        signIn(email, password)
            .then(userCredential => {
                const user = userCredential.user;
                console.log(user);
                setError('');
                form.reset();
                navigate(from, { replace: true });
                toast.success('LogIn Success!')
            })
            .catch(error => {
                toast.error(error.message);
                setError(error.message);
            })
    }


    // Password Correction
    const handleForgotPassword = () => {
        userPasswordCorrection(email)
            .then(() => {
                toast.success('Password Reset Email Send')
            })
            .catch(error => {
                setError(error.message);
                toast.error(error.message);
            })
    }


    // Collect Email from user Sign in form
    const collectEmail = (event) => {
        const email = event.target.value;
        console.log(email);
        setEmail(email);
    }

    return (

        <div className="mt-6 lg:w-2/5 md:w-1/2 sm:w-4/5 mx-auto p-8 space-y-3 rounded-xl shadow-2xl">
            <h1 className="text-2xl font-bold text-center text-gray-800">Sign In</h1>
            <form onSubmit={handleOnSubmit} className="space-y-6 ng-untouched ng-pristine ng-valid">
                <div className="space-y-1 text-sm">
                    <label htmlFor="username" className="block text-gray-700">Email</label>
                    <input onBlur={collectEmail} type="email" name="email" id="username" placeholder="email" className="w-full px-4 py-3 rounded-md border-gray-700 bg-gray-700 text-gray-100 focus:border-violet-400" required />
                </div>
                <div className="space-y-1 text-sm">
                    <label htmlFor="password" className="block text-gray-700">Password</label>
                    <input type="password" name="password" id="password" placeholder="Password" className="w-full px-4 py-3 rounded-md border-gray-700 bg-gray-700 text-gray-100 focus:border-violet-400" required />


                </div>
                <p className='text-red-400 my-0'><small>{error}</small></p>
                <button className="block w-full p-3 text-center rounded-sm text-gray-900 bg-violet-400 hover:bg-violet-500 transition duration-300">Sign in</button>
            </form>

            <div className="flex justify-end text-xs text-gray-700">
                <button onClick={handleForgotPassword} className='hover:underline'>Forgot Password?</button>
            </div>

            <div className="flex items-center pt-4 space-x-1">
                <div className="flex-1 h-px sm:w-16 bg-gray-300"></div>
                <p className="px-3 text-sm text-gray-700 ">or</p>
                <div className="flex-1 h-px sm:w-16 bg-gray-300"></div>
            </div>
            <div className="flex justify-center space-x-4">
                <button onClick={handleGoogleSignIn} aria-label="Log in with Google" className="p-3 rounded-sm text-gray-700 hover:bg-gray-100 hover:shadow-md">
                    <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="30px" height="30px">    <path d="M 15.003906 3 C 8.3749062 3 3 8.373 3 15 C 3 21.627 8.3749062 27 15.003906 27 C 25.013906 27 27.269078 17.707 26.330078 13 L 25 13 L 22.732422 13 L 15 13 L 15 17 L 22.738281 17 C 21.848702 20.448251 18.725955 23 15 23 C 10.582 23 7 19.418 7 15 C 7 10.582 10.582 7 15 7 C 17.009 7 18.839141 7.74575 20.244141 8.96875 L 23.085938 6.1289062 C 20.951937 4.1849063 18.116906 3 15.003906 3 z" /></svg>
                </button>

                <button onClick={handleFacebookSignIn} aria-label="Log in with Facebook" className="p-3 rounded-sm text-gray-700 hover:bg-gray-100 hover:shadow-md">
                    <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="30px" height="30px">    <path d="M15,3C8.373,3,3,8.373,3,15c0,6.016,4.432,10.984,10.206,11.852V18.18h-2.969v-3.154h2.969v-2.099c0-3.475,1.693-5,4.581-5 c1.383,0,2.115,0.103,2.461,0.149v2.753h-1.97c-1.226,0-1.654,1.163-1.654,2.473v1.724h3.593L19.73,18.18h-3.106v8.697 C22.481,26.083,27,21.075,27,15C27,8.373,21.627,3,15,3z" /></svg>
                </button>

                <button onClick={handleGithubSignIn} aria-label="Log in with GitHub" className="p-3 rounded-sm text-gray-700 hover:bg-gray-100 hover:shadow-md">
                    <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="30px" height="30px">    <path d="M15,3C8.373,3,3,8.373,3,15c0,5.623,3.872,10.328,9.092,11.63C12.036,26.468,12,26.28,12,26.047v-2.051 c-0.487,0-1.303,0-1.508,0c-0.821,0-1.551-0.353-1.905-1.009c-0.393-0.729-0.461-1.844-1.435-2.526 c-0.289-0.227-0.069-0.486,0.264-0.451c0.615,0.174,1.125,0.596,1.605,1.222c0.478,0.627,0.703,0.769,1.596,0.769 c0.433,0,1.081-0.025,1.691-0.121c0.328-0.833,0.895-1.6,1.588-1.962c-3.996-0.411-5.903-2.399-5.903-5.098 c0-1.162,0.495-2.286,1.336-3.233C9.053,10.647,8.706,8.73,9.435,8c1.798,0,2.885,1.166,3.146,1.481C13.477,9.174,14.461,9,15.495,9 c1.036,0,2.024,0.174,2.922,0.483C18.675,9.17,19.763,8,21.565,8c0.732,0.731,0.381,2.656,0.102,3.594 c0.836,0.945,1.328,2.066,1.328,3.226c0,2.697-1.904,4.684-5.894,5.097C18.199,20.49,19,22.1,19,23.313v2.734 c0,0.104-0.023,0.179-0.035,0.268C23.641,24.676,27,20.236,27,15C27,8.373,21.627,3,15,3z" /></svg>
                </button>
            </div>
            <p className="text-xs text-center sm:px-6 text-gray-400">Don't have an account? &nbsp;
                <Link to="/signup" className="hover:underline text-gray-700">Sign up</Link>
            </p>
        </div>

    );
};

export default Signin;